import React from 'react'
const Member = React.lazy(() => import('_root/containers/member/member'))
const MemberLogin = React.lazy(() => import('_root/containers/member/member-login'))
const MemberRegistration = React.lazy(() => import('_root/containers/member/member-registration'))
const MemberConfirmation = React.lazy(() => import('_root/containers/member/member-confirmation'))
const MemberAd = React.lazy(() => import('_root/containers/member/member-ad'))
const MemberApplications = React.lazy(() => import('_root/containers/member/member-applications'))
const MemberAds = React.lazy(() => import('_root/containers/member/member-ads'))
const MemberSettings = React.lazy(() => import('_root/containers/member/member-settings'))
const MemberProfile = React.lazy(() => import('_root/containers/member/member-profile'))
const MemberBooking = React.lazy(() => import('_root/containers/member/member-booking'))

import * as url from '_routes/url-names'
import MemberRoute from '_routes/member-route'

export default [
  {
    path: url.KONTO,
    element: <Member />,
    children: [
      { path: url.KONTO + url.LOGIN, element: <MemberLogin /> },
      { path: url.KONTO + url.REGISTRERA, element: <MemberRegistration /> },
      { path: url.KONTO + url.UPPDATERAD, element: <MemberConfirmation /> },
      { path: url.KONTO + url.ANNONS + url.ANNONSID, element: <MemberAd /> },
      { path: url.KONTO + url.ANSOKNINGAR, element: <MemberRoute><MemberApplications /></MemberRoute> },
      { path: url.KONTO + url.ANNONSER, element: <MemberRoute><MemberAds /></MemberRoute> },
      { path: url.KONTO + url.INSTALLNINGAR, element: <MemberRoute><MemberSettings /></MemberRoute> },
      { path: url.KONTO + url.PROFIL, element: <MemberRoute><MemberProfile /></MemberRoute> },
      { path: url.KONTO + url.BOKNING, element: <MemberRoute><MemberBooking /></MemberRoute> }
    ]
  }
]
